type BillingCycleType = {
  label: string
  selected?: boolean
  disabled?: boolean
}

const billingcycles: Array<BillingCycleType> = [
  {
    label: 'monthly (USD$ 60.00/month)',
    selected: true,
  },
  {
    label: 'annually (USD$ 576.00/month)',
  },
]

export default billingcycles
